import { render, staticRenderFns } from "./EmissionIndex.vue?vue&type=template&id=c3560fb8"
import script from "./EmissionIndex.vue?vue&type=script&lang=js"
export * from "./EmissionIndex.vue?vue&type=script&lang=js"
import style0 from "./EmissionIndex.vue?vue&type=style&index=0&id=c3560fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
